import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import { Component, effect, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { IgxGridComponent, IgxTabsModule } from '@infragistics/igniteui-angular';
import { DataBroadcastService } from 'src/app/core/services/broadcast/data-broadcast.service';
import { ApnUtilitiesService } from 'src/app/core/services/data/apn-utilities.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { dbErrorEntry } from 'src/app/shared/entities/dbErrorEntry';
import { ILotRateList, IParkerProfileDetail, IParkerProfileMassUpdate, IStallTypes } from 'src/app/shared/interfaces';
import { IParcsGetLotConfigurationResponse } from 'src/app/shared/code/interfaces/parcs-interfaces';
import { ParkersV2AdditionalEmailsComponent } from '../../parkers-v2-grid-components/parkers-v2-additional-emails/parkers-v2-additional-emails.component';
import { ParkersV2AdditionalVehiclesComponent } from '../../parkers-v2-grid-components/parkers-v2-additional-vehicles/parkers-v2-additional-vehicles.component';
import { ParkersV2DetailComponent } from '../../parkers-v2-grid-components/parkers-v2-detail/parkers-v2-detail.component';
import { ParkersV2EditComponent } from '../../parkers-v2-grid-components/parkers-v2-edit/parkers-v2-edit.component';
import { ParkersV2SpaceEmailComponent } from '../../parkers-v2-grid-components/parkers-v2-space-email/parkers-v2-space-email.component';
import { ParkersV2TestFormComponent } from '../../parkers-v2-grid-components/parkers-v2-test-form/parkers-v2-test-form/parkers-v2-test-form.component';
import { ClonerService } from 'src/app/core/services/helper/cloner.service';
import { DialogConfirmUpdateV2Component } from '../../parker-v2-dialogs/dialog-confirm-update-component-v2/dialog-confirm-update-v2.component';
import { ParkersV2AgreementComponent } from '../../parkers-v2-grid-components/parkers-v2-agreement/parkers-v2-agreement.component';
import { CompanyStateService } from 'src/app/core/services/state/company-state.service';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { IRowSelectionEventArgs, IRowToggleEventArgs } from 'igniteui-angular';
import { IRowExportingEventArgs } from 'igniteui-angular';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { ParcsManagementHomeComponent } from '../../parkers-v2-grid-components/parcs-management/parcs-management-home/parcs-management-home.component';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { ParkersV2AdditionalCredentialsComponent } from '../../parkers-v2-grid-components/parkers-v2-additional-credentials/parkers-v2-additional-credentials.component';
// import { IRowExpandedEventArgs, IRowCollapsedEventArgs } from 'igniteui-angular';
import { FlashParkerSettingsComponent } from '../../parker-parcs/flash-parker-settings/flash-parker-settings.component';

@Component({
  selector: 'app-parkers-v2-grid-view-main',
  templateUrl: './parkers-v2-grid-view-main.component.html',
  standalone: true,
  imports: [
    CommonModule,
    // JsonPipe,
    MatSnackBarModule,
    FormsModule,
    IgxGridModule,
    IgxTabsModule,
    IgxGridComponent,
    ParkersV2AdditionalEmailsComponent,
    ParkersV2AdditionalVehiclesComponent,
    ParkersV2DetailComponent,
    // ParkersV2EditComponent,
    ParkersV2AdditionalEmailsComponent,
    ParkersV2SpaceEmailComponent,
    // ParkersV2TestFormComponent,
    ParkersV2AgreementComponent,
    ParcsManagementHomeComponent,
    ParkersV2AdditionalCredentialsComponent,
    FlashParkerSettingsComponent,
  ],

  styleUrl: './parkers-v2-grid-view-main.component.scss',
})
export class ParkersV2GridViewMainComponent implements OnInit {
  @ViewChild('gridParkersV2MainGrid', { read: IgxGridComponent, static: true })
  public gridParkersV2MainGrid: IgxGridComponent;
  currentFilterSelected: string = 'allFilterItems';
  currentGridModeSelected: string = 'allParkersGrid';
  filteredParkerDetail?: IParkerProfileDetail | undefined;
  gridFontSize: number = 12;
  currentRowInEditMode: number = -1;
  currentlyActivePaymentRow: number = -1;
  massUpdateDisplay: boolean = false;
  massUpdateTabText: string = 'No Update...';
  gridViewSelection: number = 1;
  allParkersChecked: boolean = false;
  public screenWidth: any;
  public screenHeight: any;
  stallDescriptions: IStallTypes[] = [];
  allUpdateFlag: boolean = false;
  marketRateList: ILotRateList[] = [];
  spaceEmailDisplayStatus: boolean = false;
  expansionState: any = '';
  currentParkerIdEditPending: string = undefined;
  parkerRowIsOpen: boolean = false;
  currentParkerIdOpen: string = undefined;
  rowEventsLocked: boolean = false;
  ignoreToggleEvents: boolean = false;
  expansionStates: any;
  hasParc: boolean = false; // This parker needs to get PARC information during new Parker process
  parcName: string = ''; // This is the PARC name that this LOT is using

  @Output() handleFilterParkerEvent: EventEmitter<string> = new EventEmitter<string>();

  //Services
  parkerStateService = inject(ParkerStateService);
  snackBar = inject(MatSnackBar);
  clonerService = inject(ClonerService);
  _companyState = inject(CompanyStateService);
  _appGeneralState = inject(AppGeneralStateService);
  _dialogService = inject(MessageDialogService);
  #_parcsDataService = inject(ParcsDataService);

  clipboard: any;
  public options = {
    enabled: true,
    copyHeaders: true,
    copyFormatters: true,
    separator: '\t',
  };

  constructor(
    private router: Router,
    private dataBroadcastService: DataBroadcastService,
    private datePipeService: DatePipe,
    private dialog: MatDialog,
    private apnUtilityService: ApnUtilitiesService,
  ) {
    this.dataBroadcastService.fontSizeBroadcast.subscribe((res: any) => {
      let fontChangeCommand: string;
      fontChangeCommand = res;

      if (fontChangeCommand === '+') this.gridFontSize++;
      else this.gridFontSize--;
    });

    this._appGeneralState.updateFinishedBroadcast.subscribe((res: any) => {
      this.onMassUpdateFinished();
    });

    this._appGeneralState.parkerProfileGridRefresh.subscribe((res: any) => {
      this.gridParkersV2MainGrid.markForCheck();
    });
  }

  rowToggle(event: IRowToggleEventArgs): void {
    if (event.expanded && this.parkerStateService.isEditModeEnabled) {
      event.cancel = true;
      this._dialogService.snackBarTopCenterTimed(
        'A Parker Profile is currently being changed.  You cannot open another Parker Profile until you save or cancel the changes',
        5000,
      );
    } else {
      if (
        this.parkerStateService.isEditModeEnabled &&
        this.parkerStateService.currentParkerIdInEditMode == event.rowID
      ) {
        event.cancel = true;
        this._dialogService.snackBarTopCenterTimed(
          'You have made changes to this Parker Profile.  Submit or cancel changes before you can close it.',
          5000,
        );
        return;
      }

      if (event.expanded) {
        const expandedRowIds = Array.from(this.gridParkersV2MainGrid.expansionStates.entries())
          .filter(([rowId, expanded]) => expanded && rowId !== event.rowID)
          .map(([rowId]) => rowId);

        expandedRowIds.forEach((rowId) => this.gridParkersV2MainGrid.collapseRow(rowId));
      }
    }
  }

  public onKeyDown(keyDown: KeyboardEvent): void {
    if (keyDown.code == 'Space') {
      keyDown.stopPropagation();
    }
  }

  public onKeyDownGridDetail(keyDown: KeyboardEvent): void {
    if (keyDown.code == 'Space') {
      keyDown.stopPropagation();
    }
  }

  async ngOnInit(): Promise<void> {
    this.SetSpaceTabDisplayStatus();

    const parcsConfigSettings: IParcsGetLotConfigurationResponse = await this.getParcsInformationForLotNumber(
      this._appGeneralState.currentLotNumber,
    );

    this.hasParc = parcsConfigSettings != null;
  }

  SetSpaceTabDisplayStatus(): void {
    this.spaceEmailDisplayStatus = this.parkerStateService.GetSpaceDisableSetting(
      this._appGeneralState.currentLotNumber,
    );
  }

  onMassUpdateFinished(): void {
    this.allUpdateFlag = false;
  }

  setAllParkerUpdateCheckboxes(checkStatus: boolean): void {
    let ii: number;

    for (ii = 0; ii < this.parkerStateService.filteredParkers.length; ii++) {
      this.parkerStateService.filteredParkers[ii].massUpdateTargetFlag = checkStatus;
    }
  }

  showSpaceGridDisplayTab(companyName: string): boolean {
    //if no eligible to display space tab then return false -- cannot display
    if (this.spaceEmailDisplayStatus) {
      return false;
    }

    return true;
  }

  parkerMassUpdateResultsAlreadyExist(parkerId: string): void {
    let proceed: boolean = false;

    try {
      const dialogConfirmRemoveExistingUpdate = this.dialog.open(DialogConfirmUpdateV2Component, {});
      dialogConfirmRemoveExistingUpdate.afterClosed().subscribe((result) => {
        proceed = result;
        if (proceed) {
          this.parkerStateService.parkerUpdateList = [];
          this.addParkerToUpdateList(parkerId);
          this.parkerStateService.massUpdateResultsExist = false;
        } else {
          let jj: number;
          for (jj = 0; jj < this.parkerStateService.filteredParkers.length; jj++) {
            this.parkerStateService.filteredParkers[jj].massUpdateTargetFlag = false;
            this.allUpdateFlag = false;
          }
        }
      });
    } catch (err) {
      let errorLogEntry: dbErrorEntry = new dbErrorEntry();

      errorLogEntry.Location = 'Err: onCheckAllUpdateParkerUpdateList()';
      errorLogEntry.errorMessage = JSON.stringify(err);
      this.apnUtilityService.logErrorToDB(errorLogEntry);
    }
  }

  onSelectParker(parkerId: string): void {
    let ii: number = 0;

    let proceedResettingParkers: boolean = false;
    if (this.parkerStateService.massUpdateResultsExist) {
      this.parkerMassUpdateResultsAlreadyExist(parkerId);
    } else {
      this.addParkerToUpdateList(parkerId);
    }
  }

  addParkerToUpdateList(parkerId: string): void {
    let parkerIndexFound: number = -1;
    let ii: number;

    try {
      for (ii = 0; ii < this.parkerStateService.parkerUpdateList.length; ii++) {
        if (parkerId == this.parkerStateService.parkerUpdateList[ii].parkerId) parkerIndexFound = ii;
      }

      let parkerProfileData: IParkerProfileDetail = {} as IParkerProfileDetail;
      parkerProfileData = this.GetCurrentParkerProfileData(parkerId);

      if (parkerIndexFound == -1) {
        let newParkerUpdate: IParkerProfileMassUpdate = {} as IParkerProfileMassUpdate;

        newParkerUpdate.parkerId = parkerId;
        newParkerUpdate.companyName = parkerProfileData.companyName;
        newParkerUpdate.emailAddress = parkerProfileData.emailAddress;
        newParkerUpdate.rate = parkerProfileData.rate;
        newParkerUpdate.parkerPayType = parkerProfileData.parkerPayType;
        newParkerUpdate.invoiceDeliveryMethod = parkerProfileData.deliveryType;
        newParkerUpdate.companyChanged = false;
        newParkerUpdate.rateAssigned = false;
        newParkerUpdate.parkerPayTypeChanged = false;
        newParkerUpdate.deliveryMethodChanged = false;
        newParkerUpdate.firstName = parkerProfileData.firstName;
        newParkerUpdate.lastName = parkerProfileData.lastName;
        newParkerUpdate.isError = false;

        this.parkerStateService.parkerUpdateList.push(newParkerUpdate);
      } else {
        this.parkerStateService.parkerUpdateList.splice(parkerIndexFound, 1);
      }

      this.dataBroadcastService.validateMassUpdateEnabled.next('go');
    } catch (err) {
      console.error('Error OnSelectParker: ' + JSON.stringify(err));
    }
  }

  GetCurrentParkerProfileData(parkerId: string): IParkerProfileDetail {
    let parkerProfileData: IParkerProfileDetail = {} as IParkerProfileDetail;
    let ii: number = 0;

    for (ii = 0; ii < this.parkerStateService.filteredParkers.length; ii++) {
      if (parkerId == this.parkerStateService.filteredParkers[ii].parkerId) {
        parkerProfileData = this.parkerStateService.filteredParkers[ii];
        return parkerProfileData;
      }
    }
    return parkerProfileData;
  }

  onNavigateToParkerDetails(parkerId: string): void {
    this.storeParkerData(parkerId);
    this.parkerStateService.setEnableModeOn();
    let data = { parkerId: parkerId };
    this.router.navigate([`/parker/${parkerId}/details`]);
  }

  storeParkerData(parkerId: string): void {
    //this.parker = this.parkers;
    this.filteredParkerDetail = this.parkerStateService.filteredParkers.find((x) => x.parkerId == parkerId);
    if (this.filteredParkerDetail != undefined)
      this.parkerStateService.setParkerDetail(this.createDetailParkerProfile());
  }

  createDetailParkerProfile(): IParkerProfileDetail {
    let detailedParkerProfile: IParkerProfileDetail = {} as IParkerProfileDetail;

    detailedParkerProfile = this.filteredParkerDetail;

    detailedParkerProfile.startDateDisplay = this.datePipeService
      .transform(this.filteredParkerDetail.startDate, 'M/d/yyyy')!
      .toString();
    detailedParkerProfile.endDateDisplay = this.datePipeService
      .transform(this.filteredParkerDetail.endDate, 'dd/MM/yyyy')!
      .toString();

    if (detailedParkerProfile.endDateDisplay === '01/01/0001') {
      detailedParkerProfile.endDateDisplay = '';
    }

    if (this.filteredParkerDetail.parkerPayType.toUpperCase() === 'PARKER')
      detailedParkerProfile.tenantId = this.filteredParkerDetail.parkerId;
    else detailedParkerProfile.tenantId = this.filteredParkerDetail.companyId;

    detailedParkerProfile.stallType = this.filteredParkerDetail.stallType;

    detailedParkerProfile.taxExempt = false;

    return detailedParkerProfile;
  }

  getQSRRowBackgroundColor(rowNumber: number): string {
    if (this.currentlyActivePaymentRow === rowNumber) {
      return 'yellow';
    } else {
      if (rowNumber % 2 === 1) return '#e1e1e4';
      else return '#fff';
    }
  }

  OnCopyParkerDataToClipboard(controlName: string, displayNameForDialog: string): void {
    this.clipboard.copy(controlName);
    this.snackBar.open(`${displayNameForDialog} copied to clipboard`, '', { duration: 3000 });
  }

  onFilterParkerData(command: string): void {
    this.parkerStateService.currentParkerFilter = command;
    this.currentGridModeSelected = 'allFilterItems';
    this.currentGridModeSelected = 'allParkersGrid';
    this.currentFilterSelected = command;
    this.handleFilterParker(command);
  }

  handleFilterParker(command: string): void {
    if (command === '') return;

    if (command === 'allFilterItems')
      this.parkerStateService.setFilteredParkerData(
        this.clonerService.deepClone(this.parkerStateService.getParkerQueryResults()),
      );
    else {
      let parkerSubset: IParkerProfileDetail[];
      let allParkersClone: IParkerProfileDetail[];
      allParkersClone = this.clonerService.deepClone(this.parkerStateService.getParkerQueryResults());

      if (command === '0-9') {
        parkerSubset = allParkersClone.filter((option) => !isNaN(Number(option.lastName.charAt(0))));
        this.parkerStateService.setFilteredParkerData(this.clonerService.deepClone(parkerSubset));
      } else {
        parkerSubset = this.parkerStateService.parkerQueryResults.filter((option) =>
          option.lastName.toUpperCase().startsWith(command),
        );
        this.parkerStateService.setFilteredParkerData(this.clonerService.deepClone(parkerSubset));
      }
    }
  }

  isFilterSelected(filterCommand: string): boolean {
    let isSelected: boolean = false;

    isSelected = this.currentFilterSelected === filterCommand;

    return isSelected;
  }

  onSelectGridMode(command: string): void {
    this.currentGridModeSelected = command;
    this.currentFilterSelected = 'allFilterItems';

    // Show all Parkers
    if (command == 'allFilterItems') {
      this.onFilterParkerData(command);
      return;
    }

    if (command == 'gridExpiredRates') {
      //Get the Expired Rates List
      this.parkerStateService.setFilteredParkerData(
        this.clonerService.deepClone(this.parkerStateService.parkerExpiredRates),
      );
    } else {
      //This will be the Duplicate Key Cards List
      this.parkerStateService.setFilteredParkerData(
        this.clonerService.deepClone(this.parkerStateService.parkerDuplicateKeyCards),
      );
    }
  }

  isGridModeSelected(filterCommand: string): boolean {
    let isSelected: boolean = false;

    isSelected = this.currentGridModeSelected === filterCommand;

    return isSelected;
  }

  public onCheckOnOffAllParkersForUpdate(): void {
    let proceedResettingParkers: boolean = false;
    let proceed: boolean = false;

    try {
      if (this.parkerStateService.massUpdateResultsExist) {
        const dialogConfirmRemoveExistingUpdate = this.dialog.open(DialogConfirmUpdateV2Component, {});
        dialogConfirmRemoveExistingUpdate.afterClosed().subscribe((result) => {
          proceed = result;

          if (proceed) {
            this.parkerStateService.parkerUpdateList = [];
            this.parkerStateService.allParkersSelectedForMassUpdate =
              !this.parkerStateService.allParkersSelectedForMassUpdate;
            this.allUpdateFlag = !this.allUpdateFlag;
            this.onCheckAllUpdateParkerUpdateList();
            this.setAllParkerUpdateCheckboxes(this.allUpdateFlag);
            this.parkerStateService.massUpdateResultsExist = false;
          } else {
            let jj: number;
            for (jj = 0; jj < this.parkerStateService.filteredParkers.length; jj++) {
              this.parkerStateService.filteredParkers[jj].massUpdateTargetFlag = false;
            }
          }
        });
      } else {
        this.parkerStateService.allParkersSelectedForMassUpdate =
          !this.parkerStateService.allParkersSelectedForMassUpdate;
        this.allUpdateFlag = !this.allUpdateFlag;

        if (this.allUpdateFlag) {
          this.onCheckAllUpdateParkerUpdateList();
          this.setAllParkerUpdateCheckboxes(true);
        } else {
          this.parkerStateService.parkerUpdateList = [];
          this.setAllParkerUpdateCheckboxes(false);
        }
      }
    } catch (err) {
      let errorLogEntry: dbErrorEntry = new dbErrorEntry();

      errorLogEntry.Location = 'Err: onCheckAllUpdateParkerUpdateList()';
      errorLogEntry.errorMessage = JSON.stringify(err);
      this.apnUtilityService.logErrorToDB(errorLogEntry);
    }
  }

  onCheckAllUpdateParkerUpdateList(): void {
    let ii: number;

    try {
      this.parkerStateService.parkerUpdateList = [];

      for (ii = 0; ii < this.parkerStateService.filteredParkers.length; ii++) {
        //const index = this.parkerStateService.parkerUpdateList.findIndex(x => x.parkerId === this.parkerStateService.filteredParkers[ii].parkerId);

        //if(index === -1){
        let newParkerUpdate: IParkerProfileMassUpdate = {} as IParkerProfileMassUpdate;

        newParkerUpdate.parkerId = this.parkerStateService.filteredParkers[ii].parkerId;
        newParkerUpdate.companyName = this.parkerStateService.filteredParkers[ii].companyName;
        newParkerUpdate.emailAddress = this.parkerStateService.filteredParkers[ii].emailAddress;
        newParkerUpdate.rate = this.parkerStateService.filteredParkers[ii].rate;
        newParkerUpdate.parkerPayType = this.parkerStateService.filteredParkers[ii].parkerPayType;
        newParkerUpdate.invoiceDeliveryMethod = this.parkerStateService.filteredParkers[ii].deliveryType;
        newParkerUpdate.companyChanged = false;
        newParkerUpdate.rateAssigned = false;
        newParkerUpdate.parkerPayTypeChanged = false;
        newParkerUpdate.deliveryMethodChanged = false;
        newParkerUpdate.firstName = this.parkerStateService.filteredParkers[ii].firstName;
        newParkerUpdate.lastName = this.parkerStateService.filteredParkers[ii].lastName;

        this.parkerStateService.parkerUpdateList.push(newParkerUpdate);
        // }
      }
    } catch (err) {
      let errorLogEntry: dbErrorEntry = new dbErrorEntry();

      errorLogEntry.Location = 'Err: onCheckAllUpdateParkerUpdateList()';
      errorLogEntry.errorMessage = JSON.stringify(err);
      this.apnUtilityService.logErrorToDB(errorLogEntry);
    }
  }

  async getParcsInformationForLotNumber(lotNumber: string): Promise<IParcsGetLotConfigurationResponse> {
    let lotConfiguration: IParcsGetLotConfigurationResponse;

    try {
      lotConfiguration = await firstValueFrom(this.#_parcsDataService.getParcsLotConfigurationByLotNumber(lotNumber));
    } catch (err) {
      lotConfiguration = null;
    }
    return lotConfiguration;
  }
}
